/** Écart minimal entre deux pastilles d'un même rang, en pixels. */
export const PILL_GAP_PX = 4;

/**
 * Le rang de chaque pastille posée au-dessus du clavier, de gauche à droite.
 *
 * Deux touches voisines — un demi-ton, une tierce serrée — ont des pastilles
 * plus larges que l'écart entre elles. Côte à côte elles se recouvrent et
 * aucun nom ne se lit : celle qui ne tient pas monte d'un rang, sur le premier
 * où elle a la place.
 *
 * `items` est trié par centre croissant ; le résultat suit le même ordre.
 * Hors du rendu pour se tester sans Pixi.
 */
export function stackPills(
  items: readonly { readonly center: number; readonly width: number }[],
  gap = PILL_GAP_PX,
): number[] {
  const rowsRight: number[] = [];

  return items.map(({ center, width }) => {
    const left = center - width / 2;
    let row = rowsRight.findIndex((right) => right + gap <= left);

    if (row === -1) {
      row = rowsRight.length;
      rowsRight.push(0);
    }

    rowsRight[row] = left + width;

    return row;
  });
}
